import React from 'react';
import { ImageFadeIn } from '../components/animations/ImageFadeIn';
import { ScrollReveal } from '../components/animations/ScrollReveal';
import { Shield, HeartPulse, AlertTriangle, Target, Car, Home, Siren, Radio, Wind, Home as HomeIcon, Flame, BoxIcon } from 'lucide-react';
const ProgramsPage = () => {
  return <div className="w-full min-h-screen bg-white" data-id="element-620">
      {/* Hero Section */}
      <div className="relative min-h-[60vh] flex items-center bg-cover bg-center" style={{
      backgroundImage: "url('https://uploadthingy.s3.us-west-1.amazonaws.com/f58KckxayorY4pRqcLQxf9/000_QQ3AP-e1502868300864.webp')"
    }} data-id="element-621">
        <div className="absolute inset-0 bg-black/60" data-id="element-622"></div>
        <div className="relative z-10 w-full pt-36 sm:pt-52 md:pt-56 pb-16 sm:pb-20" data-id="element-623">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 text-center" data-id="element-624">
            <h1 className="text-3xl sm:text-5xl md:text-6xl font-bold text-white tracking-tight mb-4 sm:mb-6" data-id="element-625">
              Our Programs
            </h1>
            <p className="text-lg sm:text-xl md:text-2xl text-white/90 max-w-3xl mx-auto font-light leading-relaxed" data-id="element-626">
              Comprehensive training designed to equip Israeli civilians with
              life-saving skills
            </p>
          </div>
        </div>
      </div>
      {/* Self-Defense & Weapons Readiness */}
      <section className="py-20 sm:py-24" data-id="element-627">
        <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-628">
          <ScrollReveal animation="fade" data-id="element-629">
            <div className="text-center mb-16" data-id="element-630">
              <div className="inline-flex items-center justify-center mb-4" data-id="element-631">
                <Shield className="w-8 h-8 text-blue-500 mr-2" data-id="element-632" />
                <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 tracking-tight" data-id="element-633">
                  Self-Defense & Weapons Readiness
                </h2>
              </div>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-634">
                Equipping civilians with the skills to protect themselves and
                their communities
              </p>
            </div>
          </ScrollReveal>
          <ScrollReveal animation="scale" delay={0.2} data-id="element-635">
            <div className="mb-16" data-id="element-636">
              <div className="relative aspect-[16/9] rounded-xl overflow-hidden" data-id="element-637">
                <ImageFadeIn src="https://uploadthingy.s3.us-west-1.amazonaws.com/f58KckxayorY4pRqcLQxf9/000_QQ3AP-e1502868300864.webp" alt="Civilian woman practicing firearm training with professional instructor" className="w-full h-full object-cover" data-id="element-638" />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6" data-id="element-639">
                  <p className="text-white text-lg font-light" data-id="element-640">
                    Indoor firearms training for civilians with professional
                    instructors
                  </p>
                </div>
              </div>
            </div>
          </ScrollReveal>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-10" data-id="element-641">
            {selfDefensePrograms.map((program, index) => <ScrollReveal key={index} animation="slide-up" delay={index * 0.1} data-id="element-642">
                <div className="flex items-start" data-id="element-643">
                  <div className="mr-4 mt-1" data-id="element-644">
                    <div className="p-2 rounded-full bg-blue-100" data-id="element-645">
                      <program.icon className="w-6 h-6 text-blue-500" data-id="element-646" />
                    </div>
                  </div>
                  <div data-id="element-647">
                    <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-648">
                      {program.title}
                    </h3>
                    <p className="text-base text-gray-700 leading-relaxed" data-id="element-649">
                      {program.description}
                    </p>
                  </div>
                </div>
              </ScrollReveal>)}
          </div>
        </div>
      </section>
      {/* Medical Readiness */}
      <section className="py-20 sm:py-24 bg-gray-50" data-id="element-650">
        <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-651">
          <ScrollReveal animation="fade" data-id="element-652">
            <div className="text-center mb-16" data-id="element-653">
              <div className="inline-flex items-center justify-center mb-4" data-id="element-654">
                <HeartPulse className="w-8 h-8 text-blue-500 mr-2" data-id="element-655" />
                <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 tracking-tight" data-id="element-656">
                  Medical Readiness
                </h2>
              </div>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-657">
                Saving lives when every second counts
              </p>
            </div>
          </ScrollReveal>
          <ScrollReveal animation="scale" delay={0.2} data-id="element-658">
            <div className="mb-16" data-id="element-659">
              <div className="relative aspect-[16/9] rounded-xl overflow-hidden" data-id="element-660">
                <ImageFadeIn src="https://uploadthingy.s3.us-west-1.amazonaws.com/2RzD3Hv3ZwgDzrjzRUzjmU/0473_LMQE_IchudHatzalah_GadiYampel_1GY9847-scaled-1.jpg" alt="Medical training session" className="w-full h-auto rounded-lg" data-id="element-661" />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6" data-id="element-662">
                  <p className="text-white text-lg font-light" data-id="element-663">
                    Emergency medical response team training with patient
                    evacuation
                  </p>
                </div>
              </div>
            </div>
          </ScrollReveal>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-10" data-id="element-664">
            {medicalPrograms.map((program, index) => <ScrollReveal key={index} animation="slide-up" delay={index * 0.1} data-id="element-665">
                <div className="flex items-start" data-id="element-666">
                  <div className="mr-4 mt-1" data-id="element-667">
                    <div className="p-2 rounded-full bg-red-100" data-id="element-668">
                      <program.icon className="w-6 h-6 text-red-500" data-id="element-669" />
                    </div>
                  </div>
                  <div data-id="element-670">
                    <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-671">
                      {program.title}
                    </h3>
                    <p className="text-base text-gray-700 leading-relaxed" data-id="element-672">
                      {program.description}
                    </p>
                  </div>
                </div>
              </ScrollReveal>)}
          </div>
        </div>
      </section>
      {/* All-Hazard Emergency Response */}
      <section className="py-20 sm:py-24" data-id="element-673">
        <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-674">
          <ScrollReveal animation="fade" data-id="element-675">
            <div className="text-center mb-16" data-id="element-676">
              <div className="inline-flex items-center justify-center mb-4" data-id="element-677">
                <AlertTriangle className="w-8 h-8 text-blue-500 mr-2" data-id="element-678" />
                <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 tracking-tight" data-id="element-679">
                  All-Hazard Emergency Response
                </h2>
              </div>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-680">
                Preparing for any crisis that threatens Israeli communities
              </p>
            </div>
          </ScrollReveal>
          <ScrollReveal animation="scale" delay={0.2} data-id="element-681">
            <div className="mb-16" data-id="element-682">
              <div className="relative aspect-[16/9] rounded-xl overflow-hidden" data-id="element-683">
                <ImageFadeIn src="https://uploadthingy.s3.us-west-1.amazonaws.com/8S9Uyq78LzUKFgJpwgjEFN/IS-NEWS_Earthquake-in-Turkey-Photo-2-Israelis-at-Turkey-earthquake.jpg" alt="Emergency response team in helmets responding to a disaster scene" className="w-full h-full object-cover" data-id="element-684" />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6" data-id="element-685">
                  <p className="text-white text-lg font-light" data-id="element-686">
                    Disaster response team training in hazardous environments
                  </p>
                </div>
              </div>
            </div>
          </ScrollReveal>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-10" data-id="element-687">
            {emergencyPrograms.map((program, index) => <ScrollReveal key={index} animation="slide-up" delay={index * 0.1} data-id="element-688">
                <div className="flex items-start" data-id="element-689">
                  <div className="mr-4 mt-1" data-id="element-690">
                    <div className="p-2 rounded-full bg-amber-100" data-id="element-691">
                      <program.icon className="w-6 h-6 text-amber-600" data-id="element-692" />
                    </div>
                  </div>
                  <div data-id="element-693">
                    <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-694">
                      {program.title}
                    </h3>
                    <p className="text-base text-gray-700 leading-relaxed" data-id="element-695">
                      {program.description}
                    </p>
                  </div>
                </div>
              </ScrollReveal>)}
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <ScrollReveal animation="fade" data-id="element-696">
        <section className="bg-israel-blue text-white py-16 sm:py-20" data-id="element-697">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center" data-id="element-698">
            <h2 className="text-3xl sm:text-4xl font-bold mb-6 tracking-tight" data-id="element-699">
              Experience Our Training Center
            </h2>
            <p className="text-xl opacity-90 mb-8 max-w-2xl mx-auto font-light" data-id="element-700">
              When in Israel, come visit the state-of-the-art facilities that
              you helped build and see how we're preparing Israeli civilians for
              any threat
            </p>
            <a href="/training-center" className="inline-block px-8 py-4 bg-white text-israel-blue font-semibold rounded-lg hover:bg-gray-100 transition-colors text-lg shadow-lg" data-id="element-701">
              Explore Our Training Center
            </a>
          </div>
        </section>
      </ScrollReveal>
    </div>;
};
const selfDefensePrograms = [{
  icon: AlertTriangle,
  title: 'Situational Awareness',
  description: 'Training to identify potential dangers before they escalate, helping civilians recognize threats in their environment'
}, {
  icon: Home,
  title: 'Close-Quarters Defense',
  description: 'Tactics for countering attackers who breach homes, vehicles, or public spaces, ensuring safety in confined areas'
}, {
  icon: Car,
  title: 'Defensive Driving',
  description: 'Maneuvers for responding to roadside ambushes and vehicular attacks, keeping families safe while traveling'
}, {
  icon: Target,
  title: 'Weapons Proficiency',
  description: 'Drills focused on accuracy under stress, ensuring responsible and effective weapon use'
}, {
  icon: Shield,
  title: 'Immediate Action Drills',
  description: 'Rapid deployment of defensive measures, barricading, and organized threat engagement for community protection'
}, {
  icon: Radio,
  title: 'Alert Systems',
  description: 'Use of personal and community alert systems to coordinate quick response teams during emergencies'
}];
const medicalPrograms = [{
  icon: HeartPulse,
  title: 'Trauma Care',
  description: 'Specialized treatment for gunshot wounds, stabbings, and explosive injuries when professional help is delayed'
}, {
  icon: BoxIcon,
  title: 'Bleeding Control',
  description: 'Use of tourniquets, wound packing, and pressure bandages to stop severe bleeding in emergency situations'
}, {
  icon: Shield,
  title: 'Improvised Medical Solutions',
  description: 'Creating effective medical aids when standard supplies are unavailable, using everyday items to save lives'
}, {
  icon: Siren,
  title: 'Multiple-Casualty Triage',
  description: 'Training to prioritize care and maximize survival rates when multiple people are injured'
}, {
  icon: Car,
  title: 'Safe Extraction',
  description: 'Techniques to remove the injured from dangerous areas under fire, ensuring both rescuer and patient safety'
}, {
  icon: Radio,
  title: 'Emergency Communication',
  description: 'First responder communication protocols using radios and emergency networks to coordinate care'
}];
const emergencyPrograms = [{
  icon: Wind,
  title: 'CBRN Defense',
  description: 'Chemical-radiological attack survival training and protective measures for civilians in contaminated environments'
}, {
  icon: HomeIcon,
  title: 'Safe Room Protocols',
  description: 'Proper use, maintenance, and emergency protocols for home safe rooms (mamad)'
}, {
  icon: Flame,
  title: 'Evacuation Training',
  description: 'Organized procedures for home, forest fire, and flood evacuations to ensure family safety'
}, {
  icon: AlertTriangle,
  title: 'Earthquake Response',
  description: 'Drop-cover-hold techniques and post-quake evacuation procedures to minimize injuries during seismic events'
}, {
  icon: Home,
  title: 'Search & Rescue Basics',
  description: 'Fundamental techniques for locating and extracting victims from collapsed structures and building emergencies'
}, {
  icon: Siren,
  title: 'Emergency Coordination',
  description: 'Methods for coordinating emergency response with security operations during complex crisis situations'
}];
export default ProgramsPage;